export default __webpack_public_path__ + "static/media/deal.d303474b.ogg";